import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuth } from '@chainlit/react-client';

export default function AuthCallback() {
  const { user, setUserFromAPI } = useAuth();
  const navigate = useNavigate();

  // Fetch user in cookie-based oauth.
  useEffect(() => {
    if (!user) setUserFromAPI();
  }, []);

  useEffect(() => {
    if (user) {
      // Restore the URL the user was originally trying to reach. Full reload
      // (window.location.href) so AppWrapper re-evaluates the route against
      // the restored pathname, triggering any path-driven UI (e.g. the
      // /worksheet deep link auto-opens the Make Worksheet dialog).
      let dest = '/';
      try {
        const saved = localStorage.getItem('login_redirect_url');
        if (saved && saved.startsWith('/')) dest = saved;
        localStorage.removeItem('login_redirect_url');
      } catch {
        /* localStorage unavailable — use default */
      }
      window.location.href = dest;
    }
  }, [user]);

  return null;
}
